import type {SVGProps} from 'react';

export function Fa7SolidFileVideo(props: SVGProps<SVGSVGElement>) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width={"1em"} height={"1em"} viewBox="0 0 640 640" {...props}>
        <path fill="currentColor"
              d="M128 128c0-35.3 28.7-64 64-64h149.5c17 0 33.3 6.7 45.3 18.7l106.5 106.6c12 12 18.7 28.3 18.7 45.3V512c0 35.3-28.7 64-64 64H192c-35.3 0-64-28.7-64-64zm208-5.5V216c0 13.3 10.7 24 24 24h93.5zM208 368v96c0 17.7 14.3 32 32 32h96c17.7 0 32-14.3 32-32v-24l35 35c3.2 3.2 7.5 5 12 5c9.4 0 17-7.6 17-17v-94.1c0-9.4-7.6-17-17-17c-4.5 0-8.8 1.8-12 5l-35 35v-24c0-17.7-14.3-32-32-32h-96c-17.7 0-32 14.3-32 32z"></path>
    </svg>);
}